// src/services/authService.js

const API_URL = 'https://chat-whatsapp-backend.sugaronweb.com.mx/api';

class AuthService {
    static listeners = new Set();

    static subscribe(listener) {
        this.listeners.add(listener);
        return () => this.listeners.delete(listener);
    }

    static emit(event) {
        this.listeners.forEach(listener => listener(event));
    }

    static async login(phoneNumber, password) {
        try {
            const response = await fetch(`${API_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    phone_number: phoneNumber,
                    password: password
                })
            });
    
            const data = await response.json();
    
            // Si hay error, Laravel retorna 401 con mensaje de error
            if (!response.ok) {
                throw new Error(data.error || 'Error en la autentificación');
            }
    
            // Laravel retorna { token: 'xxx' }
            if (data.token) {
                localStorage.setItem('token', data.token);
                const userData = data.user;
                localStorage.setItem('userSystem', JSON.stringify({ id: userData.id, name: userData.name, phone_number: userData.phone_number, permission: userData.permission }));
                this.emit('login');
                
                return {
                    success: true,
                    token: data.token,
                    user: { phone_number: phoneNumber }
                };
            }
    
            throw new Error('Error en formato de respuesta');
        } catch (error) {
            throw error;
        }
    }

    static async refreshToken() {
        try {
            const token = localStorage.getItem('token');
            
            const response = await fetch(`${API_URL}/refresh`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

            const data = await response.json();

            if (!response.ok) {
                await this.logout();
                throw new Error('Sesión expirada');
            }

            if (data.token) {
                localStorage.setItem('token', data.token);
                this.emit('token-refreshed');
            }

            return data;
        } catch (error) {
            await this.logout();
            throw error;
        }
    }

    static async logout() {
        try {
            const token = this.getToken();
            
            if (token) {
                // Intentar hacer logout en el backend
                await fetch(`${API_URL}/logout`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }).catch(() => {}); // Ignoramos errores en el logout del backend
            }
        } finally {
            // Siempre ejecutamos esto, incluso si falla el logout en el backend
            localStorage.removeItem('token');
            localStorage.removeItem('userSystem');
            
            // Emitir evento antes de la redirección
            this.emit('logout');

            // Redirigir después de un pequeño delay para permitir que los listeners se ejecuten
            // setTimeout(() => {
            //     window.location.href = '/login';
            // }, 100);
        }
    }

    static getToken() {
        return localStorage.getItem('token');
    }

    static isAuthenticated() {
        return !!this.getToken();
    }

    static checkTokenExpiration(error) {
        if (error?.response?.status === 401) {
            this.logout();
            return false;
        }
        return true;
    }
}

export default AuthService;